import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { useSubscription } from "@/hooks/useSubscription";
import { useSubscriptionPlans } from "@/hooks/useSubscriptionPlans";

/**
 * Trial watermark/badge component that displays on dashboard during trial mode
 * Non-intrusive, visible but doesn't block interaction
 */
export function TrialWatermark() {
  const { subscription, isLoading } = useSubscription();
  const { getPlanLabel, isLoading: plansLoading } = useSubscriptionPlans();

  if (isLoading || plansLoading) return null;
  
  // Only show for trial or trial_pending_mandate status
  if (!subscription) return null;
  
  const { status, selectedPlanForTrial, daysRemaining } = subscription;
  
  if (status !== 'trial' && status !== 'trial_pending_mandate') return null;

  const planLabel = getPlanLabel(selectedPlanForTrial) || 'Yearly';
  
  return (
    <div className="fixed bottom-4 right-4 z-40 pointer-events-none">
      <div className="bg-amber-500/10 backdrop-blur-sm border border-amber-500/30 rounded-lg px-4 py-3 shadow-lg pointer-events-auto">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-amber-500/20 flex items-center justify-center">
            <Clock className="h-5 w-5 text-amber-600" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="border-amber-500/50 text-amber-600 bg-amber-500/10">
                TRIAL MODE
              </Badge>
              <span className="text-sm font-medium text-amber-700 dark:text-amber-400">
                {daysRemaining} days left
              </span>
            </div>
            <p className="text-xs text-muted-foreground mt-0.5">
              {status === 'trial_pending_mandate' 
                ? 'Trial शुरू करने के लिए mandate setup करें'
                : `आपका ${planLabel} plan trial के बाद automatically शुरू होगा`
              }
            </p>
            <p className="text-[10px] text-amber-600/70 mt-0.5">
              Cancel anytime • कभी भी cancel करें
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
